exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-logo {\n  text-align: center; }\n\n.auth-block p {\n  text-align: center; }\n\n.auth-block {\n  background: #bf0a24 !important; }\n\n.funds-separator {\n  border-bottom: solid 1px #abb9be;\n  padding: 10px 0; }\n\n.funds-separator:last-child {\n  border-bottom: none; }\n\n.search--input {\n  margin-left: 0px;\n  padding-left: 10px;\n  width: 300px;\n  margin-bottom: 10px; }\n\n.table-hover > tbody > .active:before {\n  background-color: rgba(0, 0, 0, 0.1); }\n\n.ba-back-top {\n  position: fixed;\n  width: 52px;\n  height: 52px;\n  cursor: pointer;\n  z-index: 9999;\n  display: none;\n  text-decoration: none;\n  right: 40px;\n  bottom: 40px !important;\n  font-size: 45px;\n  text-align: center;\n  opacity: 0.4;\n  color: #00abff;\n  background-color: rgba(0, 0, 0, 0.75);\n  border-radius: 50%;\n  line-height: 46px; }\n  .ba-back-top:hover {\n    opacity: 0.8; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baBackTop/baBackTop.scss
// module id = 826
// module chunks = 8